import { icon, node } from "~/util/dom";
import { IRibbonItemReviewData } from "./interfaces";
import { WIDTH_REVIEW } from "./const";

interface IRibbonItemReview extends IRibbonItemReviewData {
	width?: number;
	onClick?: () => void;
}

export default class RibbonItemReview {
	_data: IRibbonItemReview;

	_dom: {
		container: HTMLAnchorElement;
	};

	constructor(data: IRibbonItemReview) {
		this._data = {
			width: WIDTH_REVIEW,
			onClick: () => {},
			...data,
		};

		this._build();
	}

	get container() {
		return this._dom.container;
	}

	get width() {
		return this._data.width;
	}

	get data() {
		return this._data;
	}

	_build() {
		const container = node("a", { className: "ribbonItemReview", href: this._data.link });
		const header = node("div", { className: "ribbonItemReview__header" });
		const headerInner = node("div", { className: "ribbonItemReview__headerInner" });
		const bottom = node("div", { className: "ribbonItemReview__bottom" });
		const userCont = node("div", { className: "ribbonItemReview__userCont" });
		const userAvatar = node("div", { className: "ribbonItemReview__userAvatar" });
		const userInfo = node("div", { className: "ribbonItemReview__userInfo" });
		const userName = node("p", { className: "ribbonItemReview__userName" });
		const userReviews = node("p", { className: "ribbonItemReview__userReviews" });

		const starsCont = node("div", { className: "ribbonItemReview__starsCont" });
		const desc = node("p", { className: "ribbonItemReview__desc clamp-lines-4" });
		const date = node("p", { className: "ribbonItemReview__date" });

		if (this._data.image) {
			const bgImage = node("img", { className: "ribbonItemReview__headerImage" });
			const bgCover = node("div", { className: "ribbonItemReview__headerImageCover" });

			bgImage.src = this._data.image;
			header.classList.add("has-image");
			header.append(bgImage, bgCover);
		}

		const starsBanner = node("mapy-review-stars");

		container.style.width = `${this._data.width}px`;
		starsBanner.disabled = true;
		starsBanner.setAttribute("size", "16");
		starsBanner.setAttribute("gap", "2");
		/* eslint-disable-next-line */
		starsBanner.setAttribute("value", ((this._data.rating / 100) * 5).toString());
		starsCont.append(starsBanner);

		if (this._data.avatar) {
			const userAvatarImage = node("img", { className: "ribbonItemReview__userAvatarImage" });

			userAvatar.append(userAvatarImage);
			userAvatarImage.src = this._data.avatar;
		}

		userName.textContent = this._data.userName;
		userReviews.textContent = this._data.reviewsCount;
		userReviews.append(icon("ribbon-drop-right"));
		userInfo.append(userName, userReviews);
		userCont.append(userAvatar, userInfo);
		header.append(headerInner);
		headerInner.append(userCont, starsCont);
		desc.textContent = this._data.text;
		date.textContent = this._data.date;
		bottom.append(desc, date);
		container.append(header, bottom);

		this._dom = {
			container,
		};

		container.addEventListener("click", event => {
			event.stopPropagation();
			event.preventDefault();
			this._data.onClick();
		});
	}
}
